import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpResourceUrls, HttpUrlGenerator } from '@ngrx/data';
import { Update } from '@ngrx/entity';
import { TeamMemberInterface } from '@shared/api';
import { isNumber } from 'lodash-es';
import { map, Observable } from 'rxjs';
import { CustomDefaultDataService } from '../../custom-default-data-service.class';
import { EntityTypeEnum } from '../../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class TeamMembersDataService extends CustomDefaultDataService<TeamMemberInterface> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super(EntityTypeEnum.TeamMember, http, httpUrlGenerator);
  }

  registerUrls(httpResourceUrls: HttpResourceUrls): void {
    this.entityUrl = httpResourceUrls.entityResourceUrl;
    this.entitiesUrl = httpResourceUrls.collectionResourceUrl;
  }

  override delete(key: number | string): Observable<number | string> {
    return this.http
      .post(`${this.entityUrl}/delete-member`, {
        teamMemberGuids: isNumber(key)
          ? [key]
          : key.split(',').length > 0
            ? key.split(',')
            : [key],
      })
      .pipe(map(() => key));
  }

  override update(
    update: Update<TeamMemberInterface>,
  ): Observable<TeamMemberInterface> {
    return this.http
      .post(`${this.entityUrl}/edit-member`, {
        teamMemberGuids: isNumber(update.id)
          ? [update.id]
          : update.id.split(',').length > 0
            ? update.id.split(',')
            : [update.id],
        ...update.changes,
      })
      .pipe(
        map(
          () =>
            ({
              guid: update.id as string,
              ...update.changes,
            }) as TeamMemberInterface,
        ),
      );
  }
}
